<template>
  <el-container  style="display: block;">

    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"

        height="1500"
        max-height="850"
        width='2780'
      	border
      	style="width: 2780px;height: 800px;text-align: center;margin: 0;">

        <el-table-column
          width="200"
          label="名字"
           >
           <template slot-scope="scope">
               <div>{{scope.row.gname}}</div>



           </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="结束"
           >
           <template slot-scope="scope">
               <el-button type="success" @click="sends('结束',scope.row.shebeiid)">结束</el-button>
           </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="睡眠"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('睡眠',scope.row.shebeiid)">睡眠</el-button>
           </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="醒来"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('醒来',scope.row.shebeiid)">醒来</el-button>
           </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="不听"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('不听',scope.row.shebeiid)">不听</el-button>
           </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="听"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('听',scope.row.shebeiid)">听</el-button>
           </template>
        </el-table-column>
        
        <el-table-column
          width="95"
          label="闭嘴"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('闭嘴',scope.row.shebeiid)">闭嘴</el-button>
           </template>
        </el-table-column>


        <el-table-column
          width="95"
          label="讲话"
           >
           <template slot-scope="scope">
               <el-button type="primary" @click="sends('讲话',scope.row.shebeiid)">讲话</el-button>
           </template>
        </el-table-column>

        <el-table-column
          width="95"
          label="切换"
           >
           <template slot-scope="scope">
               <el-button type="danger" @click="sends('切换',scope.row.shebeiid)">切换</el-button>
           </template>
        </el-table-column>
        </el-table>
      </template>

    </el-row>



  </el-container>

</template>

<script>

  export default {
    data() {
       return {

         tableData:[],


      }
    },
	directives: {
    },
    created() {
      let that = this
      RongIMLib.RongIMClient.init('pvxdm17jpdv7r')
      that.beforeIm() //设置监听，必须先设置监听，再连接
      that.nowIm()
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();

    },


	methods:{
    beforeIm(){
      let that = this
      // 连接状态监听器
      RongIMClient.setConnectionStatusListener({
       onChanged: function (status) {
        // status 标识当前连接状态
        switch (status) {
         case RongIMLib.ConnectionStatus.CONNECTED:
          console.log('链接成功');
          break;
         case RongIMLib.ConnectionStatus.CONNECTING:
          console.log('正在链接');
          break;
         case RongIMLib.ConnectionStatus.DISCONNECTED:
          console.log('断开连接');
          break;
         case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
          console.log('其他设备登录');
          break;
         case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
          console.log('域名不正确');
          break;
         case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
          console.log('网络不可用');
          break;
        }
       }
      });
     // 消息监听器
       RongIMClient.setOnReceiveMessageListener({
        // 接收到的消息
        onReceived: function (message) {
         // 判断消息类型
         switch(message.messageType){
          case RongIMClient.MessageType.TextMessage:
           // message.content.content => 文字内容
           //----------------------------重要-------把获取的消息存放在store中，全局公用homeIm.vue要使用
           console.log('8080',message,message.content.content)

           break;
          case RongIMClient.MessageType.VoiceMessage:
           // message.content.content => 格式为 AMR 的音频 base64
           break;
          case RongIMClient.MessageType.ImageMessage:
           // message.content.content => 图片缩略图 base64
           // message.content.imageUri => 原图 URL
           break;
          case RongIMClient.MessageType.LocationMessage:
           // message.content.latiude => 纬度
           // message.content.longitude => 经度
           // message.content.content => 位置图片 base64
           break;
          case RongIMClient.MessageType.RichContentMessage:
           // message.content.content => 文本消息内容
           // message.content.imageUri => 图片 base64
           // message.content.url => 原图 URL
           break;
          case RongIMClient.MessageType.InformationNotificationMessage:
           // do something
           break;
          case RongIMClient.MessageType.ContactNotificationMessage:
           // do something
           break;
          case RongIMClient.MessageType.ProfileNotificationMessage:
           // do something
           break;
          case RongIMClient.MessageType.CommandNotificationMessage:
           // do something
           break;
          case RongIMClient.MessageType.CommandMessage:
           // do something
           break;
          case RongIMClient.MessageType.UnknownMessage:
           // do something
           break;
          default:
           // do something
         }
        }
       });
     },
    nowIm(){
       //自己的token------从接口获取，写到缓存
        var token = '+FxE3BBqankHPvm+dGVFkPsdQPK82N8o7GwigPIxsXQ=@7ksh.cn.rongnav.com;7ksh.cn.rongcfg.com'
        RongIMClient.connect(token, {
         onSuccess: function(userId) {
          console.log('Connect successfully. ' + userId);
         },
         onTokenIncorrect: function() {
          console.log('token 无效');
         },
         onError: function(errorCode){
          var info = '';
          switch (errorCode) {
           case RongIMLib.ErrorCode.TIMEOUT:
            info = '超时';
            break;
           case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
            info = '不可接受的协议版本';
            break;
           case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
            info = 'appkey不正确';
            break;
           case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
            info = '服务器不可用';
            break;
          }
          console.log(info);
         }
        });
       },

    sends(name,id){
      let that = this
        let msg = new RongIMLib.TextMessage({ content: name});
        let conversationType = RongIMLib.ConversationType.PRIVATE; // 单聊, 其他会话选择相应的消息类型即可
        let targetId = id; // 目标 Id

        RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
         onSuccess: function (message) {
          // message 为发送的消息对象并且包含服务器返回的消息唯一 Id 和发送消息时间戳

          that.$message({
          	type: 'sucsess',
          	message: '操作成功'
          });

          console.log('Send successfully',message,message.content.content);

         },
         onError: function (errorCode, message) {
          let info = '';
          switch (errorCode) {
           case RongIMLib.ErrorCode.TIMEOUT:
            info = '超时';
            break;
           case RongIMLib.ErrorCode.UNKNOWN:
            info = '未知错误';
            break;
           case RongIMLib.ErrorCode.REJECTED_BY_BLACKLIST:
            info = '在黑名单中，无法向对方发送消息';
            break;
           case RongIMLib.ErrorCode.NOT_IN_DISCUSSION:
            info = '不在讨论组中';
            break;
           case RongIMLib.ErrorCode.NOT_IN_GROUP:
            info = '不在群组中';
            break;
           case RongIMLib.ErrorCode.NOT_IN_CHATROOM:
            info = '不在聊天室中';
            break;
          }
          console.log('发送失败: ' + info + errorCode);
         }
        });
    },

    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:4,
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/equipmentList'
    	})
    	.then(res=>{
    		this.tableData = res.data;


    	})
    	.catch(err=>{

    	});
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
  .yuansushangxian{
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/equipmentzk.vue